<template>
  <!-- Main Sidebar Container -->
  <div class="sidebar-container">
    <aside class="main-sidebar sidebar-light-success elevation-2"
      :class="$store.getters.getDarkMode ? 'dark-mode text-white' : ''">
      <a href="/" class="brand-link">
        <img src="/img/Logo-STS.png" alt="Logo STS" class="brand-image img-circle elevation-1" />
        <span class="font-weight-bold" style="font-size: 14px" :class="darkMode ? 'text-white' : 'text-dark'">
          <b> Sistema de Transporte S.A. </b>
        </span>
      </a>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- SidebarSearch Form -->
        <div class="form-inline">
          <div class="input-group mt-2">
            <input class="form-control form-control-sidebar" type="search" placeholder="Buscar" aria-label="Search"
              v-model="filtro" />
            <div class="input-group-append">
              <button class="btn btn-sidebar">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            <li class="nav-item" v-for="menu in filterMenu" :key="menu.id">
              <a href="#" class="nav-link active">
                <i class="nav-icon" :class="menu.icono"></i>
                <p>
                  {{ menu.nombre }}
                  <i class="right fas fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview pl-2" v-if="menu.nivel2.length > 0">
                <li class="nav-item" :class="$store.getters.getDarkMode ? 'text-white' : ''"
                  v-for="nivel2 in menu.nivel2" :key="nivel2.id">
                  <router-link :to="nivel2.ruta" class="nav-link"
                    :class="[$route.fullPath == nivel2.ruta ? 'active' : '', $store.getters.getDarkMode ? 'text-white' : 'text-dark']">
                    <i class="nav-icon" :class="nivel2.icono"></i>
                    <p>{{ nivel2.nombre }}</p>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
      <div class="sidebar-footer brand-link text-center">
        <a href="https://stsoperador.com/" target="_blank">
          <img src="/img/Logo-STS.png" alt="SOS Contingencias" style="width: 55px; opacity: 0.5"
            class="img-circle elevation-1" />
        </a>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: "NavBarLeft",

  data() {
    return {
      filtro: "",
      //empresa: this.$store.getters.getUser.empresa,
    };
  },
  computed: {
    filterMenu() {
      if (this.$store.state.menus) {
        return this.$store.state.menus
          .map((res1) => {
            const nuevosNiveles2 = res1.nivel2
              .map((res2) => {
                const nMenu = res2.nombre.toString().toLowerCase();
                const search = this.filtro.toLowerCase();
                return nMenu.includes(search) ? res2 : null;
              })
              .filter(Boolean); // Filtra los elementos nulos

            return nuevosNiveles2.length > 0
              ? { ...res1, nivel2: nuevosNiveles2 }
              : null;
          })
          .filter(Boolean); // Filtra los elementos nulos
      } else {
        return this.$store.state.menus;
      }
    },
  },
};
</script>

<style>
.sidebar {
  position: relative;
}

.sidebar-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar {
  position: relative;
  flex: 1;
  /* Para que ocupe todo el espacio restante dentro de .sidebar-container */
  max-height: calc(100% - 130px);
  /* Ajusta la altura máxima según tus necesidades */
  overflow-y: auto;
  /* Agrega desplazamiento vertical si el contenido excede la altura máxima */
}
</style>
